var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-card',{staticClass:"overflow-hidden",attrs:{"dark":""}},[_c('v-select',{attrs:{"items":_vm.seasonsMapped,"item-text":"displayName","item-value":"id","label":"Season"}}),_c('pre',[_c('code',[_vm._v(_vm._s(_vm.seasonsMapped))])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }